import { apiClient } from './ApiClient'

export interface GeneralSettings {
  // Regional Settings
  timeZone: string
  dateFormat: string
  timeFormat: string
  defaultLanguage: string
  firstDayOfWeek: number
  // Business Hours
  businessHoursStart: string
  businessHoursEnd: string
  workingDays: string
  // Ticket Settings
  autoCloseInactiveTicketsAfterDays: number
  defaultTicketPriority: string
  ticketNumberPrefix: string
  // Portal Settings
  enableCustomerPortalRegistration: boolean
  // Attachment Settings
  maxAttachmentSizeMB: number
  allowedFileTypes: string
}

export interface NotificationSettings {
  emailNotifications: boolean
  teamsNotifications: boolean
  slackNotifications: boolean
  teamsWebhookUrl?: string
  slackWebhookUrl?: string
}

export interface SecuritySettings {
  sessionTimeout: number
  passwordMinLength: number
  requireUppercase: boolean
  requireLowercase: boolean
  requireNumbers: boolean
  requireSpecialChars: boolean
  enableTwoFactor: boolean
}

export interface SlaSettings {
  policies: {
    [key: string]: {
      responseHours: number
      resolutionHours: number
    }
  }
}

export interface SystemSettings {
  general: GeneralSettings
  notifications: NotificationSettings
  security: SecuritySettings
  sla: SlaSettings
}

export class SystemSettingsService {
  private basePath = '/systemsettings'

  async getSystemSettings(): Promise<SystemSettings> {
    // apiClient.get() already extracts response.data.data and returns it directly
    return await apiClient.get<SystemSettings>(this.basePath)
  }

  async updateGeneralSettings(settings: GeneralSettings): Promise<GeneralSettings> {
    // apiClient.put() already extracts response.data.data and returns it directly
    return await apiClient.put<GeneralSettings>(`${this.basePath}/general`, settings)
  }

  async updateNotificationSettings(settings: NotificationSettings): Promise<NotificationSettings> {
    // apiClient.put() already extracts response.data.data and returns it directly
    return await apiClient.put<NotificationSettings>(`${this.basePath}/notifications`, settings)
  }

  async updateSecuritySettings(settings: SecuritySettings): Promise<SecuritySettings> {
    // apiClient.put() already extracts response.data.data and returns it directly
    return await apiClient.put<SecuritySettings>(`${this.basePath}/security`, settings)
  }

  async updateSlaSettings(settings: SlaSettings): Promise<SlaSettings> {
    // apiClient.put() already extracts response.data.data and returns it directly
    return await apiClient.put<SlaSettings>(`${this.basePath}/sla`, settings)
  }
}

export const systemSettingsService = new SystemSettingsService()
